/**
 * Training module — study-level roles a training can be scoped to.
 * Deliberately the short list the client asked for on the 4 Aug call
 * ("PI, coordinator, all site staff — not the 43-44 item delegation
 * list"), not the full `Role` enum — platform-only roles and sponsor
 * personas never hold a study delegation.
 *
 * Shared between the eISF Master Data catalog form (sets the doc
 * type's default) and the binder upload card (per-upload override) so
 * both pickers stay in sync.
 */
export const TRAINING_ROLE_OPTIONS = [
  { value: 'principal_investigator', label: 'Principal Investigator' },
  { value: 'sub_investigator', label: 'Sub-Investigator' },
  { value: 'coordinator', label: 'Study Coordinator' },
  { value: 'site_admin', label: 'Site Admin' },
  { value: 'site_study_designer', label: 'Site Study Designer' },
  { value: 'regulatory_specialist', label: 'Regulatory Specialist' },
  { value: 'site_pharma', label: 'Pharmacist' },
  { value: 'monitor', label: 'Monitor' },
] as const;
